import usepreviewAndDownloadCSV from '../hooks/usePreviewAndDownloadCSV';
import Loading from './Loading';
import { BulkEmaillPreviewProps } from '../interface/interface';

const BulkEmailPreviewAndSendNotification = (props: BulkEmaillPreviewProps) => {
  const [loading, downloadCSV, validCsv] = usepreviewAndDownloadCSV();

  if (loading) return <Loading />;

  const handleButton = async () => {
    const result = await downloadCSV(props.token, props.taskExecutionId);
    props.isvalidCSV(result?.validCsv!);
    props.isCsvDownloaded(result?.validCsv!);
  };

  return (
    <div className="flex flex-col items-center justify-center h-[300px]">
      <button
        type="submit"
        onClick={handleButton}
        className="bg-primary-blue-500 border border-primary-blue-500 text-white px-4 py-2 rounded"
      >
        Download CSV
      </button>
      {!validCsv ? (
        <div className="text-primary-blue-400 mt-5 font-semibold">
          No Data to download
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export default BulkEmailPreviewAndSendNotification;
